import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Role } from 'src/app/models';
import { AuthGuard } from 'src/app/services/auth/auth-guard';
import { BatchUpdateComponent } from './batch-update/batch-update.component';
import { CategoryFilterDetailComponent } from './category-filters/category-filter-detail/category-filter-detail.component';
import { CategoryFiltersComponent } from './category-filters/category-filters.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ProductErrorsComponent } from './product-errors/product-errors.component';
import { ProductStockEntriesComponent } from './product-stock-entries/product-stock-entries.component';
import { ProductStockNotificationsComponent } from './product-stock-notifications/product-stock-notifications.component';
import { ShopCategoriesComponent } from './shop-categories/shop-categories.component';
import { ShopCategoryDetailComponent } from './shop-categories/shop-category-detail/shop-category-detail.component';
import { ShopGroupDetailComponent } from './shop-groups/shop-group-detail/shop-group-detail.component';
import { ShopGroupFormComponent } from './shop-groups/shop-group-form/shop-group-form.component';
import { ShopGroupsComponent } from './shop-groups/shop-groups.component';
import { ShopProductsComponent } from './shop-products.component';
import { ShopReviewsComponent } from './shop-reviews/shop-reviews.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'catalog'
  },
  {
    path: 'catalog',
    component: ShopProductsComponent
  },
  {
    path: 'categories',
    component: ShopCategoriesComponent
  },
  {
    path: 'categories/category/new',
    component: ShopCategoryDetailComponent
  },
  {
    path: 'categories/category/:categoryId',
    component: ShopCategoryDetailComponent
  },
  {
    path: 'catalog/product/:productId',
    component: ProductDetailComponent
  },
  {
    path: 'filters',
    component: CategoryFiltersComponent
  },
  {
    path: 'filters/new',
    component: CategoryFilterDetailComponent
  },
  {
    path: 'filters/filter/:filterId',
    component: CategoryFilterDetailComponent
  },
  {
    path: 'reviews',
    component: ShopReviewsComponent
  },
  {
    path: 'batch-update',
    component: BatchUpdateComponent,
    canActivate: [
      () =>
        inject(AuthGuard).canActivatePermissions([
          Role.Full_Administrator,
          Role.Portfolio
        ])
    ]
  },
  {
    path: 'avise-me',
    component: ProductStockNotificationsComponent
  },
  {
    path: 'product-errors',
    component: ProductErrorsComponent
  },
  {
    path: 'stock-entries',
    component: ProductStockEntriesComponent
  },
  {
    path: 'groups',
    component: ShopGroupsComponent
  },
  {
    path: 'groups/new',
    component: ShopGroupFormComponent
  },
  {
    path: 'groups/group/:groupId',
    component: ShopGroupDetailComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductsRoutingModule {}
